<div style="height: 100%;" data-cy="erx-validation-data-container">
    <div class="section-header" data-cy="erx-validation-data-header">
        <div class="section-header-title" data-cy="erx-validation-data-title">eRX Validation</div>
    </div>
    <div data-cy="erx-validation-data-issues" style="height: 540px; overflow-y: auto; padding: 10px;">
        <table align="center" border="0" cellpadding="1" cellspacing="1" style="width:100%; padding: 10px;"
            data-cy="erx-validation-table">
            <tbody>
                <tr data-cy="erx-validation-header-row">
                    <td style="background-color:#ff3333" data-cy="erx-validation-issues-header">Validation Issues</td>
                </tr>
                @for (error of data; track error) {
                <tr data-cy="erx-validation-row">
                    <td data-cy="erx-validation-error">
                        <p>{{error}}</p>
                    </td>
                </tr>
                }
                @if (additionalErr) {
                <tr data-cy="erx-validation-additional-row">
                    <td data-cy="erx-validation-additional-error">
                        <p>{{additionalErr}}</p>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    <div mat-dialog-actions data-cy="erx-validation-actions"
        style="display: flex; flex-flow: row-reverse; padding: 10px;">
        <button mat-button class="tdo-save tdo-button" (click)="onCloseClick()" data-cy="erx-validation-close-button">Close</button>
    </div>
</div>